import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { getStats } from '../../../../selectors/fund/polls';
import styles from './PollsHome.scss';


const cx = classNames.bind(styles);

// const propTypes = {
//   stats: React.PropTypes.shape({
//     new: React.PropTypes.number,
//     active: React.PropTypes.number,
//     ended: React.PropTypes.number,
//     count: React.PropTypes.number,
//   }).isRequired,
// };

const defaultProps = {
};


/**
* Компонент страницы со статистикой, когда не выбран ни один из опросов
*/
const PollsHome = ({ stats }) => {
  const isEmpty = !stats.count;
  return (
    <div className={cx({ root: true, empty: isEmpty })}>
      { !isEmpty
        ?
          <div className={styles.block}>
            <div className={styles.item}>
              <span>Новые опросы</span>
              <span className={styles.numNew}>{stats.new || 0}</span>
            </div>
            <div className={styles.item}>
              <span>Текущие опросы</span>
              <span className={styles.numCur}>{stats.active || 0}</span>
            </div>
            <div className={styles.item}>
              <span>Завершено</span>
              <span className={styles.numFin}>{stats.ended || 0}</span>
            </div>
          </div>
        : <div>Пока что нет ни одного опроса</div>
      }
    </div>
  );
};

// PollsHome.propTypes = propTypes;
PollsHome.defaultProps = defaultProps;

const mapStateToProps = (store, ownProps) => {
  const { params: { type } } = ownProps;
  const isOwn = (type === 'mypolls');
  return ({
    stats: getStats(store, isOwn),
  });
};

export default connect(mapStateToProps)(PollsHome);
